<template>
  <b-navbar toggleable="md" type="dark" class="navbar bg-dark">
    <router-link class="navbar-brand" to="/">
      <i class="fas fa-home" role="img" aria-label="Home"></i>
    </router-link>
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav>
        <b-nav-item v-for="item in items" v-bind:key="item.name" :to="item.path">
          {{item.title}}
          <span v-if="item.path == $route.path" class="sr-only">({{$t('current')}})</span>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <li>
          <languageSwitcher :locales="$parent.locales"></languageSwitcher>
        </li>
      </b-navbar-nav>
    </b-collapse>

  </b-navbar>
</template>

<i18n src='@/assets/locales/shared.json'></i18n>
<i18n>
en:
  current: "current"
  team: "About us"
de:
  current: "aktiv"
  team: "Über uns"
</i18n>

<script>
import bNavbar from 'bootstrap-vue/es/components/navbar/navbar';
import bNavbarNav from 'bootstrap-vue/es/components/navbar/navbar-nav';
import bNavbarToggle from 'bootstrap-vue/es/components/navbar/navbar-toggle';
import bNavItem from 'bootstrap-vue/es/components/nav/nav-item';
import bCollapse from 'bootstrap-vue/es/components/collapse/collapse';

import languageSwitcher from '@/components/LanguageSwitcher';

export default {
  name: 'Navbar',
  computed: {
    items: function items() {
      return [
        {
          path: '/team',
          title: this.$t('team'),
        },
        /*
        {
          path: '/contact',
          title: this.$t('shared.contact'),
        },
        */
      ];
    },
  },
  components: {
    'b-navbar': bNavbar,
    'b-navbar-nav': bNavbarNav,
    'b-navbar-toggle': bNavbarToggle,
    'b-nav-item': bNavItem,
    'b-collapse': bCollapse,
    languageSwitcher,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  nav {
    position: fixed;
    width: 100%;
    z-index: 3;
    user-select: none;
  }

  #logo {
    width: 32px;
    height: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue